import * as React from "react";
import FileDropZone from "./FileDropZone";

interface IFileUploadOnSubmitProps {
    files?: any[];
    maxFiles: number;
    theme?: any;
    uploadText: string;
}

interface IFileUploadOnSubmitActions {
    onDrop(acceptedFiles: File[], rejectedFiles?: File[]): void;
    onSubmit(): void;
    onCancel(): void
}

type FileUploadOnSubmitPropsAndActions = IFileUploadOnSubmitProps & IFileUploadOnSubmitActions;

interface IFileUploadOnSubmitState {
    error: string;
}

class FileUploadOnSubmit extends React.Component<FileUploadOnSubmitPropsAndActions, any> {

    constructor(props, context) {
        super(props, context);

        this.state = {
            error: undefined
        }
    }

    onDrop(files) {

        if (files.length <= this.props.maxFiles) {
            this.setState({
                error: undefined
            })
            this.props.onDrop(files);
        } else {
            this.setState({
                error: `Maximum of ${this.props.maxFiles} file${this.props.maxFiles > 1 ? 's' : ''} per upload.`
            })
        }
    }

    render() {
        const { files, onSubmit, onCancel, theme, uploadText } = this.props;

        return (<>
            <FileDropZone
                className="my-2 border rounded"
                onDrop={this.onDrop.bind(this)}
                theme={theme}
            />
            {
                this.state.error
                    ? <div className="alert alert-danger invalid-feedback d-block">{this.state.error}</div>
                    : files && files.length > 0
                        ? <div className="col-12 col-md-6">
                            <div className="d-flex justify-content-between">
                                <button className="btn btn-primary btn-lg" onClick={onSubmit.bind(this)}>
                                    {uploadText} {files.length} {files.length === 1 ? 'FILE' : 'FILES'}
                                </button>
                                <button className="btn btn-danger btn-lg" onClick={onCancel.bind(this)}>CANCEL</button>
                            </div>
                            {
                                files.map(file => (
                                    <div className="alert alert-info py-2 my-1 d-flex flex-row justify-content-between" key={file.name}>
                                        {file.name} <span className="badge badge-pill badge-primary p-2">{file.size} bytes</span>
                                    </div>))
                            }
                        </div>
                        : null
            }
        </>
        );
    }
}

export default FileUploadOnSubmit;